module.exports = __webpack_public_path__ + "static/img/superhouse.f5245f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/superhouse.png
// module id = D8hD
// module chunks = 1